export const loginPageTranslationsFr = {
  heroAlt: 'Image principale de CHiME agent',
  heroTitle: 'CHiME agent',
  heroDescription:
    'Simplifiez votre flux de travail grâce aux données extraites par IA à partir de formulaires numérisés. CHiME agent permet une révision rapide et précise ainsi qu’une transition fluide du document à la commande.',
  loginButtonLabel: 'Connexion en tant qu’employé J&J',
  loginButtonArrow: '→',
};
